import { render, staticRenderFns } from "./goodsManage.vue?vue&type=template&id=e2b6ad06&scoped=true"
import script from "./goodsManage.vue?vue&type=script&lang=js"
export * from "./goodsManage.vue?vue&type=script&lang=js"
import style0 from "./goodsManage.vue?vue&type=style&index=0&id=e2b6ad06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b6ad06",
  null
  
)

export default component.exports